import { ReactNode, useEffect } from "react";
import { AnalyticsContext } from "./context";
import { UserData } from "@/entities/users/types";
import { AccountData } from "@/entities/accounts/types";

interface AnalyticsProviderProps {
  children: ReactNode;
  environment?: string;
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
  children,
  environment = import.meta.env.VITE_DEPLOY_ENV || "dev"
}) => {
  useEffect(() => {
    pendo.initialize({
      visitor: {
        id: "VISITOR-UNIQUE-ID"
      },
      account: {
        environment: environment
      }
    });
  }, [environment]);

  const track = (event: string, properties: Record<string, any> = {}) => {
    // Merge environment into all tracking events
    pendo.track(event, { ...properties, environment });
  };

  const identify = (user: UserData, account: AccountData) => {
    if (user && account) {
      pendo.identify({
        visitor: {
          id: user.id,
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          role: user.role
        },
        account: {
          id: account.id,
          accountName: account.name,
          environment: environment
        }
      });
    }
  };

  return (
    <AnalyticsContext.Provider
      value={{
        track,
        identify
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};
